import React from 'react';

const styles = {
  page: {
    minHeight: '100vh',
    background: 'var(--bg)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
    animation: 'fadeIn 0.4s ease',
  },
  card: {
    background: 'var(--surface)',
    border: '1px solid var(--border)',
    borderRadius: 'calc(var(--radius) * 2)',
    boxShadow: 'var(--shadow)',
    padding: '40px 48px',
    width: '100%',
    maxWidth: '440px',
  },
  logo: {
    fontFamily: "'DM Mono', monospace",
    fontSize: '13px',
    fontWeight: 500,
    letterSpacing: '0.1em',
    color: 'var(--accent)',
    textTransform: 'uppercase',
    marginBottom: '32px',
    display: 'block',
  },
  title: {
    fontSize: '24px',
    fontWeight: 600,
    letterSpacing: '-0.02em',
    marginBottom: '6px',
    color: 'var(--text)',
  },
  subtitle: {
    fontSize: '14px',
    color: 'var(--text-muted)',
    marginBottom: '32px',
  },
};

const fadeInStyle = `
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(8px); }
    to   { opacity: 1; transform: translateY(0); }
  }
`;

export default function AuthLayout({ title, subtitle, children }) {
  return (
    <>
      <style>{fadeInStyle}</style>
      <div style={styles.page}>
        <div style={styles.card}>
          <span style={styles.logo}>woody.wtf</span>
          <h1 style={styles.title}>{title}</h1>
          {subtitle && <p style={styles.subtitle}>{subtitle}</p>}
          {children}
        </div>
      </div>
    </>
  );
}
